<template>
  <div class="setBooks_box">
    <div class="setBooks" v-if="showPage">
      <div class="header clear">
        <form class="search" @submit.prevent="search($event)" v-if="service.length != 0">
          <input type="text" placeholder="搜索书籍" class="field" v-model="keywords">
          <span :class="{'clearBtn': keywords.trim().length>0}" @click="clearInput($event)"></span>
          <img src="../../../static/new icon/search.png" alt="" @click="search($event)">
          <!-- <button type="button" name="button" class="button green" @click="search($event)">搜索</button> -->
        </form>
        <div class="" style="float: right;" v-if="service.length != 0">
          <div class="selectService">
            <!-- <selecter :selectData="service" :autoIsShow="service.length==1?false:true" selectObj="service" @selecter="selecter" :selecterText="serviceText"></selecter> -->
            <origin-select :data="service" selectObj="service" :selectId="serviceId" :defValue="service.length===1?'':'全部服务'" @selecter="selecter"></origin-select>
          </div>
          <div class="selectGrads">
            <!-- <selecter :selectData="grads" :autoIsShow='true' selectObj="grad" @selecter="selecter" :selecterText="gradText"></selecter> -->
            <origin-select :data="grads" selectObj="grads" :selectId="gradId" :defValue="grads.length=== 1?'':'全部年级'" @selecter="selecter"></origin-select>
          </div>
        </div>
      </div>
      <article class="book_list clear" @scroll="handleScroll()" ref="viewBooks">
        <ul class="clear">
          <li v-for="item in catalog" :key="item.id">
            <book :booksData="item" :type="1" @setTop="setTop"></book>
          </li>
        </ul>
        <div class="loading_books" v-if="loading">
          <div class="load_line"></div>
          <p>正在加载中...</p>
        </div>
      </article>
      <div v-if="catalog.length==0 && !isSearch && service.length!=0" class="noCatalog clear">
        <img src="./../../assets/img/null.png" alt="" />
        <p>没有找到符合条件的书籍</p>
      </div>
      <div v-if="service.length==0" class="noCatalog clear">
        <img src="./../../assets/img/null.png" alt="" />
        <p>没有可以布置作业的书籍</p>
        <p>您可以联系"教育顾问"获取帮助</p>
      </div>
      <div v-if="catalog.length==0 && pageIndex==1 && isSearch" class="noResult clear">
        <img src="./../../assets/img/null.png" alt="" />
        <p>没有找到符合条件的书籍</p>
      </div>

      <!-- <paging :PagenumId="pageIndex" :PageCount="pageCount" @mypagenum="pageNum" v-show="catalog.length!=0 && service.length!=0" v-if="pull_data"></paging> -->
      <!-- <div class="pull" @click="pull_work" v-else>
				加载更多
			</div> -->
    </div>
    <div class="prev">
      <button class="button" @click="back">上一步</button>
    </div>
  </div>
</template>
<script>
import book from "./../book/book.vue";
import paging from "./../paging/paging.vue";
import OriginSelect from "./../../components/originSelect/originSelect";
import selecter from "./../selecter/selecter.vue";
import grads from "./../../data/grads";
import fetch from "./../../fetch";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    book,
    paging,
    selecter,
    OriginSelect
  },
  props: ["loadData"],
  data() {
    return {
      showPage: false,
      catalog: [],
      service: [],
      grads: grads,
      keywords: "",
      serviceName: "",
      serviceId: 0,
      params: {},
      gradId: "",
      pageIndex: 1,
      pageCount: 2,
      catalogues: [],
      LastBookArr: [], //最近布置书
      gradText: "全部年级",
      serviceText: "全部服务",
      pull_data: true,
      isSearch: false,
      classIds: "",
      loading: false,
      loadMore: true
    };
  },
  created() {
    this.$nextTick(() => {
      let params = this.$route.query;
      // this.serviceId = window.localStorage.getItem('serviceId')
      
      if (params.classIdstr) {
        this.classIds = params.classIdstr;
        window.sessionStorage.setItem(
          "classIds",
          JSON.stringify({ classId: this.classIds })
        );
      } else {
        this.classIds = JSON.parse(
          window.sessionStorage.getItem("classIds")
        ).classId;
      }

      // window.addEventListener('load', this.windowOnLoad);

      this.setWorks({ contents: [] });
      this.setSuject([]);
      this.setCatalog([]);

      this.getServices();
      this.getCatalog();
    });
  },
  watch: {
    $route: ["getServices", "getCatalog"],
    loadData(val) {
      if (
        val.loadMore &&
        val.currentName.indexOf("setHomework") &&
        this.pageIndex < this.pageCount
      ) {
        this.loading = true;
        this.pull_work();
      }
    }
  },
  methods: {
    ...mapActions(["setWorks", "removeWorks", "setSuject", "setCatalog"]),
    ...mapGetters([
      'getWorks'
    ]),
    windowOnLoad() {
      this.pageIndex = 1;
      let path = this.$route.path;
      if (path.indexOf("/api") > -1) {
        this.pull_data = false;
      }
    },
    clearInput(e) {
      this.keywords = "";
    },
    search(e) {
      this.isSearch = true;
      if (!this.keywords.trim()) {
        this.getCatalog();
      }
      this.pageIndex = 1;
      this.setParams();
      this.getCatalog();
    },
    selecter(obj) {
      if (obj.key == "grads") {
        if (isNaN(obj.index)) {
          this.gradId = "";
        } else {
          this.gradId = this.grads[obj.index].id;
          this.gradText = obj.value;
        }
        window.localStorage.setItem("gradId", this.gradId)
      } else if (obj.key == "service") {
        if (isNaN(obj.index)) {
          this.serviceId = 0;
        } else {
          this.serviceId = this.service[obj.index].id;
          this.serviceText = obj.value;
        }
        window.localStorage.setItem("serviceId", this.serviceId)
      }

      this.pageIndex = 1;
      this.getCatalog();
    },
    setParams() {
      let classList = this.getWorks().classList
      this.params = {
        serviceId: this.serviceId,
        classIds: this.classIds,
        gradeId: this.gradId,
        keyWords: this.keywords.trim(),
        pageIndex: this.pageIndex,
        pageSize: 10
      };
    },
    getServices() {
      if (
        window.sessionStorage.service &&
        window.sessionStorage.service != "underfined"
      ) {
        this.service = JSON.parse(window.sessionStorage.getItem("service"));
        this.gradId = window.localStorage.getItem("gradId") * 1;
        let serviceId = window.localStorage.getItem('serviceId')
        let serviceArr = this.service.filter(item => {
          return item.id == serviceId
        })
        if (serviceArr.length) {
          this.serviceId = serviceId
        } else if (this.service.length == 1) {
          this.serviceText = this.service[0].name;
          this.serviceId = this.service[0].id;
        }
      }
    },
    getCatalog() {
      this.setParams();
      let _this = this;
      fetch.serviceProducts(this.params).then(res => {
        if (!res) {
          _this.catalog = [];
          return false;
        }
        if (!res.data.pageList) {
          return false;
        }
        if (_this.pageIndex == res.data.pageIndex) {
          let catalogData = res.data.pageList;
          _this.pageCount = Math.ceil(
            res.data.totalCount / _this.params.pageSize
          );
          if ( _this.pageIndex !== 1) {
            _this.catalog = _this.catalog.concat(catalogData);
          } else {
            _this.catalog = [];
            _this.catalog = catalogData;
          }
        }
        _this.showPage = true;
        _this.loading = false;
        _this.getServiceText(_this.serviceId);
      });
    },
    setTop(res) {
      let params = {
        productid: res.productId,
        serviceid: res.serviceId,
        istop: res.top
      };
      fetch.setBookTop(params).then(res => {
        if (res.ret || res.errcode) {
          return false;
        }
        // 置顶成功后刷新当前列表，置顶的显示在第一个
        this.catalog  = []
        this.$toast("置顶成功!");
        this.pageNum(1)
      });
    },
    getServiceText(id) {
      let services = this.service;
      for (let item of services) {
        if (item.id == id) {
          this.serviceName = item.name;
        }
      }
    },
    pageNum(pageIndex) {
      this.pageIndex = pageIndex;
      this.getCatalog();
    },
    pull_work() {
      this.pageIndex++;
      this.getCatalog();
    },
    back() {
      this.$router.push({ path: "selectGrade", query: { bookType: 1 } });
    },

    // 滚动加载更多书籍
    handleScroll() {
      let scrollTop = this.$refs.viewBooks.scrollTop; //scrollTop为滚动条在Y轴上的滚动距离
      let clientHeight = this.$refs.viewBooks.clientHeight; //clientHeight为内容可视区域的高度。
      let scrollHeight = this.$refs.viewBooks.scrollHeight; //scrollHeight为内容可视区域的高度加上溢出（滚动）的距离
      if ((scrollTop + clientHeight ===  scrollHeight)  && scrollTop > 0) {
        this.loadMore = true;
        this.pull_work();
      } else {
        this.loadMore = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// setBooks.vue?4933f92a